export const defaultChannel = 'default-channel';